/**
 * For Google Tag Manager
 */
'use strict';

const root = typeof window === 'undefined' ? global : window;
root.dataLayer = root.dataLayer || [];
module.exports = root.dataLayer;
